export default [
    {
        path: '/tendero/ayuda',
        meta: { nombre: 'información para los usuario' },
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda').then(m => m.default || m),
        children: [
            {
                path: 'consultas-frecuentes',
                name: 'tendero.ayuda.frecuentes',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/preguntas-frecuentes').then(m => m.default || m),
            },
            {
                path: 'Términos y Condiciones',
                name: 'tendero.ayuda.terminos-condiciones',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/terminos-condiciones').then(m => m.default || m),
            },
            {
                path: 'Política de privacidad',
                name: 'tendero.ayuda.politica-privacidad',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/politica-privacidad').then(m => m.default || m),
            }
        ]
    }
]
